import { SalesCounterpartTypeahead } from 'components/shared/SalesCounterpartTypeahead/SalesCounterpartTypeAhead.withFilterApi';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { FC, useCallback } from 'react';

import type { ColumnProps } from './model';

interface ClientColumnProps extends ColumnProps<Nullable<ISalesCounterpart>> {}

export const GridClientColumn: FC<ClientColumnProps> = ({ value, id, setCellValue }) => {
  const onChange = useCallback((val: any) => setCellValue(id, val), [id, setCellValue]);

  return (
    <SalesCounterpartTypeahead
      e2e={id}
      selectedItem={value || null}
      onSelectedItemChanged={onChange}
      className="w-100"
    />
  );
};

GridClientColumn.displayName = 'GridClientColumn';
